import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "v-my-tasks__performance" }
const _hoisted_2 = { class: "v-my-tasks__performance-row" }
const _hoisted_3 = {
  key: 0,
  class: "v-my-tasks__performance-loading"
}
const _hoisted_4 = { class: "v-my-tasks__header" }
const _hoisted_5 = { class: "v-my-tasks__body" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "v-my-tasks__date-label" }
const _hoisted_8 = { class: "company__name" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = {
  key: 0,
  class: "note__icon"
}
const _hoisted_11 = { class: "app" }
const _hoisted_12 = { class: "v-users__badge driver__name" }
const _hoisted_13 = {
  key: 0,
  class: "note__icon"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 0,
  class: "custom__problem--info"
}
const _hoisted_16 = { class: "title" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 1,
  class: "custom__problem"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "icon"
}
const _hoisted_22 = { class: "td__dropdown" }
const _hoisted_23 = { class: "td__dropdown" }
const _hoisted_24 = { class: "td__dropdown" }
const _hoisted_25 = { class: "problem__group" }
const _hoisted_26 = {
  key: 0,
  class: "v-tasks__loading-more"
}
const _hoisted_27 = {
  key: 1,
  class: "v-tasks__end"
}
const _hoisted_28 = { class: "new-modal" }
const _hoisted_29 = { class: "description__footer" }
const _hoisted_30 = { class: "new-modal" }
const _hoisted_31 = { class: "auto-complete" }
const _hoisted_32 = { class: "description__footer" }

import { onMounted, ref, computed, watch, nextTick, onUnmounted } from "vue";
import {
  SearchMd,
  Clipboard,
  ChevronDown,
  Pencil02,
  LinkExternal02,
  InfoCircle,
  X,
} from "utruckin-icons";
import CommonDropdown from "@/components/common/CommonDropdown.vue";
import CommonSearch from "@/components/common/CommonSearch.vue";
import CommonTable from "@/components/common/CommonTable.vue";
import CommonButton from "@/components/common/CommonButton.vue";
import CustomCard from "@/components/custom/CustomCard.vue";
import { useTaskStore } from "@/features/tasks/task.store";
import { INewTask, ITask, ITaskData } from "@/features/tasks/task.types";
import CommonStatus from "@/components/common/CommonStatus.vue";
import { TaskStatus } from "@/features/tasks/task.enum";
import { DateTime } from "luxon";
import { useUserStore } from "@/features/users/user.store";
import { useNotification } from "@/utils/notification";
import { IDropdown } from "@/types/main";
import { useAppStore } from "@/store/app.store";
import { ICompany } from "@/features/company/company.types";
import CustomTableDropdown from "@/components/custom/CustomTableDropdown.vue";
import TaskAdditionalWorkTypes from "@/components/custom/TaskAdditionalWorkTypes.vue";
import { taskService } from "@/features/tasks/task.service";
import { IDriver } from "@/features/drivers/drivers.types";
import { IWorkType } from "@/features/work-types/work-type.types";
import { useDriverStore } from "@/features/drivers/drivers.store";
import { useCompanyStore } from "@/features/company/company.store";
import { useWorkTypeStore } from "@/features/work-types/work-type.store";
import { useKpiStore } from "@/features/kpi/kpi.store";
import CommonModal from "@/components/common/CommonModal.vue";
import CommonInput from "@/components/common/CommonInput.vue";
import { useArchiveStore } from "@/features/archive/archive.store";
import { companyService } from "@/features/company/company.service";
import { driverService } from "@/features/drivers/drivers.service";
import { workTypeService } from "@/features/work-types/work-type.service";
import CustomTab from "@/components/custom/CustomTab.vue";
import { kpiService } from "@/features/kpi/kpi.service";

type PerformancePeriod = "today" | "month_to_date";

interface MyPerformanceStatistics {
  tasks: number;
  points: number;
  in_progress: number;
  on_hold: number;
  done: number;
  closed: number;
  qa_failed: number;
  closedRate: number;
}

const PAGE_SIZE = 50;

export default /*@__PURE__*/_defineComponent({
  __name: 'MyTasksView',
  setup(__props) {

const taskStore = useTaskStore();
const userStore = useUserStore();
const appStore = useAppStore();
const driverStore = useDriverStore();
const companyStore = useCompanyStore();
const workTypeStore = useWorkTypeStore();
const kpiStore = useKpiStore();
const archiveStore = useArchiveStore();

const { pushNotification } = useNotification();

const loading = ref(false);
const tasks = ref<ITaskData[]>([]);
const collapsedDates = ref<Record<string, boolean>>({});

const search = ref<string>("");
const status = ref<string>("");

const taskNumber = ref<number>(0);
const taskNumberLoading = ref<boolean>(false);
const isAdmin = ref<boolean>(false);

const companies = ref<ICompany[]>([]);
const drivers = ref<IDriver[]>([]);
const problems = ref<IWorkType[]>([]);
const additionalWorkTypes = ref<IWorkType[]>([]);

const performancePeriod = ref<PerformancePeriod>("today");

const performanceTabs = [
  { label: "Today", value: "today" },
  { label: "Month", value: "month_to_date" },
];

const kpiStatistics = ref<MyPerformanceStatistics | null>(null);
let kpiRequestVersion = 0;

const companyLoading = ref(false);
const driverLoading = ref(false);
const problemLoading = ref(false);
const kpiLoading = ref(false);
const newTaskStatus = ref<string>("new");
const description = ref<string>("");
const newModal = ref(false);

const archiveModal = ref(false);
const archiveReason = ref<string>("");
const archiveModalItem = ref<ITaskData | null>(null);
const isSaving = ref<boolean>(false);

const newTask = ref<INewTask>({
  company_id: "",
  driver_id: "",
  work_type_id: "",
  priority: "",
  assignee_id: "",
});

// const company = ref<string>("");
// const driver = ref<string>("");
// const statusTask = ref<string>("");
// const workType = ref<string>("");

const dropdown1 = ref();
const dropdown2 = ref();
const dropdown3 = ref();

let searchTimer: ReturnType<typeof setTimeout> | null = null;

const page = ref(1);
const hasMore = ref(true);
const isLoadingMore = ref(false);
const scrollContainer = ref<HTMLElement | null>(null);
const sentinel = ref<HTMLElement | null>(null);
let observer: IntersectionObserver | null = null;

const STATUS_COLORS: Record<TaskStatus, string> = {
  [TaskStatus.NEW]: "--color-system-blue",
  [TaskStatus.INFORM]: "--color-system-grey",
  [TaskStatus.IN_PROGRESS]: "--color-system-orange",
  [TaskStatus.ON_HOLD]: "--color-system-yellow",
  [TaskStatus.DONE]: "--color-system-green",
  [TaskStatus.QA_FAILED]: "--color-system-red",
  [TaskStatus.CLOSED]: "--color-system-green",
};

const companyItems = computed(() =>
  (companies.value || []).map((c: any) => ({
    value: c.id,
    name: c.name,
    app: c.provider_name,
  }))
);

const driverItems = computed(() =>
  (drivers.value || []).map((c: any) => ({
    value: c.id,
    name: c.name,
    app: c.truck_number,
  }))
);

const problemItems = computed(() =>
  (problems.value || []).map((c: any) => ({
    value: c.id,
    name: c.name,
    app: String(c.base_points),
  }))
);

const hasUserHasAction = (item: ITaskData) => {
  return (
    userStore.userProfile &&
    (userStore.userProfile.id == item.assignee_id ||
      userStore.userProfile.role == "super_admin" ||
      userStore.userProfile.role == "admin" ||
      userStore.userProfile.role == "supervisor")
  );
};

const formatStatusLabel = (key: string) =>
  key.replace(/_/g, "_").replace(/\b\w/g, (c) => c.toUpperCase());

const statusItems = (
  Object.keys(TaskStatus) as Array<keyof typeof TaskStatus>
).map((key) => ({
  value: TaskStatus[key],
  name: formatStatusLabel(key),
  color: STATUS_COLORS[TaskStatus[key]],
}));

const summaryCards = [
  {
    label: "Total Tasks",
    name: "tasks",
  },
  {
    label: "KPI Points",
    name: "points",
  },
  {
    label: "In Progress",
    name: "in_progress",
    bg: "--color-orange-light",
  },
  {
    label: "On Hold",
    name: "on_hold",
    bg: "--color-yellow-light",
  },
  {
    label: "Done",
    name: "done",
    bg: "--color-green-light",
  },
  {
    label: "Closed",
    name: "closed",
    bg: "--color-green-light",
  },
  {
    label: "QA Failed",
    name: "qa_failed",
    bg: "--color-red-light",
  },
] as const;

const loadMyPerformance = async () => {
  const userId = userStore.userProfile?.id;
  if (!userId) return;

  const version = ++kpiRequestVersion;
  kpiLoading.value = true;

  try {
    const { data } = await kpiService.getMonthlyStatistics({
      assignee_id: userId,
      period: performancePeriod.value,
    });

    if (version !== kpiRequestVersion) return;

    const result = data.items?.[0];
    const counts = result?.status_counts ?? {};

    const totalTasks = Number(result?.total_tasks ?? 0);
    const closed = Number(counts.closed ?? 0);

    kpiStatistics.value = {
      tasks: totalTasks,
      points: Number(result?.total_points ?? 0),
      in_progress: Number(counts.in_progress ?? 0),
      on_hold: Number(counts.on_hold ?? 0),
      done: Number(counts.done ?? 0),
      closed,
      qa_failed: Number(counts.qa_failed ?? 0),
      closedRate: totalTasks > 0 ? Math.round((closed / totalTasks) * 100) : 0,
    };
  } catch (error: any) {
    if (version === kpiRequestVersion) {
      pushNotification(
        error.response?.data?.detail || "Failed to load performance statistics",
        "error"
      );
    }
  } finally {
    if (version === kpiRequestVersion) {
      kpiLoading.value = false;
    }
  }
};

watch(performancePeriod, () => {
  void loadMyPerformance();
});

const getStatusEnumKey = (qaStatus: string) => {
  const key = (Object.keys(TaskStatus) as Array<keyof typeof TaskStatus>).find(
    (k) => TaskStatus[k] === qaStatus
  );
  return key ? formatStatusLabel(key) : null;
};

const toggleDate = (date: string) => {
  collapsedDates.value[date] = !collapsedDates.value[date];
};

const isDateCollapsed = (date: string) => collapsedDates.value[date];

const groupedByDate = computed(() => {
  const dateMap = new Map<string, ITaskData[]>();

  if (tasks.value && tasks.value.length) {
    for (const task of tasks.value) {
      const date = task.created_time
        ? DateTime.fromISO(task.created_time, { zone: "utc" })
            .setZone("America/New_York")
            .toFormat("yyyy-MM-dd")
        : "Unknown";

      if (!dateMap.has(date)) {
        dateMap.set(date, []);
      }

      dateMap.get(date)!.push(task);
    }
  }

  return Array.from(dateMap.entries()).map(([date, items]) => ({
    date,
    items,
  }));
});

function datepickerToUtcDateOnly(d: string | Date | null | undefined) {
  if (!d) return "";

  const date =
    typeof d === "string"
      ? DateTime.fromISO(d, { zone: "utc" })
      : DateTime.fromJSDate(d, { zone: "utc" });

  return date.setZone("America/New_York").toFormat("HH:mm:ss");
}

const getTaskNumber = async () => {
  const data = await taskStore.getAlertQueueCount(
    taskNumberLoading,
    userStore.userProfile?.team_id
  );
  taskNumber.value = data.count;
};

const getNewTask = async () => {
  const data = await taskStore.takeAlert(taskNumberLoading);
  if (data) {
    pushNotification("Successfully added", "success");
    window.location.reload();
  }
};

let taskFilterVersion = 0;

const fetchTasks = async (
  requestedPage: number,
  append: boolean,
  version: number
): Promise<boolean> => {
  const loadingRef = append ? isLoadingMore : loading;
  loadingRef.value = true;

  const filters = {
    ...taskStore.myTaskFilter,
    page: requestedPage,
    per_page: PAGE_SIZE,
  };

  try {
    const { data } = await taskService.getMyQueue(filters);

    if (version !== taskFilterVersion) {
      return false;
    }

    const items: ITaskData[] = data.items ?? [];

    tasks.value = append ? [...tasks.value, ...items] : items;

    page.value = requestedPage;
    taskStore.myTaskFilter.page = requestedPage;
    taskStore.myTaskFilter.per_page = PAGE_SIZE;

    hasMore.value =
      data.has_more !== undefined ? data.has_more : items.length === PAGE_SIZE;

    return true;
  } catch (error: any) {
    if (version === taskFilterVersion) {
      pushNotification(
        error.response?.data?.detail || "Failed to load tasks",
        "error"
      );

      if (append) {
        hasMore.value = false;
      }
    }

    return false;
  } finally {
    if (append) {
      isLoadingMore.value = false;
    } else if (version === taskFilterVersion) {
      loading.value = false;
    }
  }
};

const resetAndFetch = async () => {
  const version = ++taskFilterVersion;

  page.value = 1;
  hasMore.value = true;
  loading.value = true;

  await fetchTasks(1, false, version);
};

const loadMore = async () => {
  if (
    loading.value ||
    isLoadingMore.value ||
    searchTimer !== null ||
    !hasMore.value
  ) {
    return;
  }

  const version = taskFilterVersion;
  const nextPage = page.value + 1;

  await fetchTasks(nextPage, true, version);
};

let companySearchVersion = 0;
let driverSearchVersion = 0;
let problemSearchVersion = 0;

const fetchCompanyOptions = async (searchText = "") => {
  const version = ++companySearchVersion;

  try {
    const { data } = await companyService.getSimpleCompanies({
      ...companyStore.commonSimpleFilter,
      search: searchText.trim(),
      page: 1,
    });

    if (version !== companySearchVersion) return;

    companies.value = data.items ?? [];
  } catch (error) {
    if (version === companySearchVersion) {
      console.error("Failed to load companies", error);
    }
  }
};

const fetchDriverOptions = async (
  searchText = "",
  companyId = newTask.value.company_id
) => {
  const version = ++driverSearchVersion;

  if (!companyId || newTask.value.company_name) {
    drivers.value = [];
    return;
  }

  try {
    const { data } = await driverService.getSimpleDrivers({
      ...driverStore.commonSimpleFilter,
      search: searchText.trim(),
      company_id: companyId,
      page: 1,
    });

    if (
      version !== driverSearchVersion ||
      newTask.value.company_id !== companyId
    ) {
      return;
    }

    drivers.value = data.items ?? [];
  } catch (error) {
    if (version === driverSearchVersion) {
      console.error("Failed to load drivers", error);
    }
  }
};

const fetchProblemOptions = async (searchText = "") => {
  const version = ++problemSearchVersion;

  try {
    const { data } = await workTypeService.getWorkTypes({
      is_active: true,
      search: searchText.trim(),
    });

    if (version !== problemSearchVersion) return;

    problems.value = data;
  } catch (error) {
    if (version === problemSearchVersion) {
      console.error("Failed to load work types", error);
    }
  }
};

const getList = async () => {
  if (searchCompanyTimer) clearTimeout(searchCompanyTimer);
  if (searchDriverTimer) clearTimeout(searchDriverTimer);
  if (searchProblemTimer) clearTimeout(searchProblemTimer);

  searchCompanyTimer = null;
  searchDriverTimer = null;
  searchProblemTimer = null;

  companyStore.commonSimpleFilter.search = "";
  driverStore.commonSimpleFilter.search = "";
  workTypeStore.commonFilter.search = "";

  // Invalidate previous searches before reloading reference lists.
  companySearchVersion++;
  driverSearchVersion++;
  problemSearchVersion++;

  const companyVersion = companySearchVersion;
  const problemVersion = problemSearchVersion;

  // Invalidate pending driver requests for previous companies.
  drivers.value = [];

  const [companiesResponse, problemsResponse] = await Promise.all([
    companyService.getSimpleCompanies({
      ...companyStore.commonSimpleFilter,
      search: "",
      page: 1,
    }),
    workTypeService.getWorkTypes({
      is_active: true,
      search: "",
    }),
  ]);

  const fetchedCompanies = companiesResponse.data;
  const fetchedProblems = problemsResponse.data as IWorkType[];

  await resetAndFetch();

  await loadMyPerformance();

  if (companyVersion === companySearchVersion) {
    companies.value = fetchedCompanies.items;
  }

  if (problemVersion === problemSearchVersion) {
    problems.value = fetchedProblems; // All Tasks
  }

  additionalWorkTypes.value = fetchedProblems;

  newTask.value = {
    company_id: "",
    driver_id: "",
    work_type_id: "",
    priority: "",
    assignee_id: "",
  };

  await getTaskNumber();
};

const nextStatus = async (item: ITaskData) => {
  if (item.status == "new") {
    const data = await taskStore.startTask(loading, item.id);
    if (data) {
      pushNotification("Successfully changed", "success");
      await getList();
    }
  } else if (item.status == "in_progress") {
    const data = await taskStore.doneTask(loading, item.id);
    if (data) {
      pushNotification("Successfully changed", "success");
      await getList();
    }
  }
};

const confirmStatus = async (item: ITaskData) => {
  if (item.status == "in_progress") {
    const data = await taskStore.doneTask(loading, item.id);
    if (data) {
      pushNotification("Successfully changed", "success");
      await getList();
    }
  }
};

const formatToEdt = (date: any) => {
  if (!date) return "";

  return date.split("T")[1] == "11:00:00.000Z"
    ? DateTime.fromISO(date, { zone: "utc" })
        .setZone("America/New_York")
        .toFormat("LLL d")
    : DateTime.fromISO(date, { zone: "utc" })
        .setZone("America/New_York")
        .toFormat("LLL d, HH:mm ZZZZ");
};

const tooltipContent = (list: any[]) =>
  list
    ?.map((item) => `<p>${item.label} - ${formatToEdt(item.date)}</p>`)
    ?.join("");

const availableStatusItems = (item: ITaskData) => {
  let allStatus: any[] = [];

  if (item.status == "new") {
    allStatus = (
      Object.keys({
        IN_PROGRESS: "in_progress",
        ON_HOLD: "on_hold",
        DONE: "done",
      }) as Array<keyof typeof TaskStatus>
    ).map((key) => ({
      value: TaskStatus[key],
      name: formatStatusLabel(key),
      color: STATUS_COLORS[TaskStatus[key]],
    }));
  } else if (item.status == "in_progress") {
    allStatus = (
      Object.keys({
        ON_HOLD: "on_hold",
        DONE: "done",
      }) as Array<keyof typeof TaskStatus>
    ).map((key) => ({
      value: TaskStatus[key],
      name: formatStatusLabel(key),
      color: STATUS_COLORS[TaskStatus[key]],
    }));
  } else if (item.status == "on_hold") {
    allStatus = (
      Object.keys({
        IN_PROGRESS: "in_progress",
        DONE: "done",
      }) as Array<keyof typeof TaskStatus>
    ).map((key) => ({
      value: TaskStatus[key],
      name: formatStatusLabel(key),
      color: STATUS_COLORS[TaskStatus[key]],
    }));
  } else if (item.status == "qa_failed") {
    allStatus = (
      Object.keys({
        IN_PROGRESS: "in_progress",
        ON_HOLD: "on_hold",
        DONE: "done",
      }) as Array<keyof typeof TaskStatus>
    ).map((key) => ({
      value: TaskStatus[key],
      name: formatStatusLabel(key),
      color: STATUS_COLORS[TaskStatus[key]],
    }));
  }

  allStatus.push({
    value: "archive",
    name: "ARCHIVE",
    color: "",
  });

  return allStatus;
};

const selectStatus = async (item: ITaskData, status: IDropdown) => {
  if (item.status == "on_hold") {
    const data = await taskStore.resumeTask(loading, item.id);
    if (data) {
      if (status.value == "in_progress") {
        pushNotification("Successfully changed", "success");
        await getList();
      } else {
        const data = await taskStore.doneTask(loading, item.id);
        if (data) {
          pushNotification("Successfully changed", "success");
          await getList();
        }
      }
    }
  } else {
    if (status.value == "on_hold") {
      const data = await taskStore.holdTask(loading, item.id);
      if (data) {
        pushNotification("Successfully changed", "success");
        await getList();
      }
    } else if (status.value == "in_progress") {
      const data = await taskStore.startTask(loading, item.id);
      if (data) {
        pushNotification("Successfully changed", "success");
        await getList();
      }
    } else if (status.value == "done") {
      const data = await taskStore.doneTask(loading, item.id);
      if (data) {
        pushNotification("Successfully changed", "success");
        await getList();
      }
    } else if (status.value == "archive") {
      openArchiveModal(item);
    }
  }
};

const createNewTask = async () => {
  if (isSaving.value) return;
  if (
    !problems.value.length ||
    !newTask.value.company_id ||
    !newTask.value.driver_id ||
    !newTask.value.work_type_id
  ) {
    return;
  }

  try {
    if (newTask.value.company_name) {
      newTask.value.company_id = "";
      delete newTask.value.company_id;
    }

    if (newTask.value.driver_name) {
      newTask.value.driver_id = "";
      delete newTask.value.driver_id;
    }

    if (newTaskStatus.value == "new") {
      newTask.value.assignee_id = userStore.userProfile?.id as string;
      await taskStore.createTask(loading, newTask.value, (data: any) => {
        if (data) {
          if (Object.keys(data).length) {
            pushNotification("Successfully added", "success");
            getList();
          }
        }
      });
    } else {
      let result: any = { ...newTask.value };
      result.description = description.value;
      delete result.assignee_id;
      await taskStore.createInformTask(loading, result, (data: any) => {
        if (data) {
          if (Object.keys(data).length) {
            pushNotification("Successfully added", "success");
            getList();
            newTaskStatus.value = "new";
            description.value = "";
          }
        }
      });
    }
  } finally {
    isSaving.value = false;
  }
};

const createItems = (type: string) => {
  let allStatus: any[];

  if (type == "new") {
    allStatus = (
      Object.keys({
        INFORM: "inform",
      }) as Array<keyof typeof TaskStatus>
    ).map((key) => ({
      value: TaskStatus[key],
      name: formatStatusLabel(key),
      color: STATUS_COLORS[TaskStatus[key]],
    }));
  } else {
    allStatus = (
      Object.keys({
        NEW: "new",
      }) as Array<keyof typeof TaskStatus>
    ).map((key) => ({
      value: TaskStatus[key],
      name: formatStatusLabel(key),
      color: STATUS_COLORS[TaskStatus[key]],
    }));
  }

  return allStatus;
};

const dropdownSelect = (e: any) => {
  if (e.value === "inform") {
    newModal.value = true;
    description.value = "";
  } else {
    newTaskStatus.value = "new";
  }
};

const saveModal = async () => {
  newTaskStatus.value = "inform";
  newModal.value = false;
  newTask.value.work_type_id = "26317c42-8a8e-4666-b78a-eca83fbf1701";
  await nextTick();
};

const editModal = () => {
  newModal.value = true;
};

const refreshTaskWorkTypes = async (taskId: string) => {
  try {
    const { data } = await taskService.getTaskById(taskId);

    const index = tasks.value.findIndex((task) => task.id === taskId);

    if (index === -1) return;

    const current = tasks.value[index];

    tasks.value[index] = {
      ...current,
      ...data,
      isEditingProblem: current.isEditingProblem,
    };
  } catch (err: any) {
    pushNotification(
      err.response?.data?.detail || "Failed to refresh task",
      "error"
    );
  }
};

const updateProblem = async (item: ITaskData) => {
  if (!item.work_type_id) return;

  await taskStore.changeTaskWorkType(
    loading,
    item.id,
    { work_type_id: item.work_type_id },
    (data: any) => {
      if (data) {
        pushNotification("Successfully added", "success");
        getList();
      }
    }
  );
};

function enterFirst() {
  const el = dropdown2.value?.[0];

  if (!el) return;
  el.focus();
}

const enterSecond = async () => {
  const el = dropdown3.value?.[0];

  if (!el) return;
  el.focus();
};

const goLink = (item: any) => {
  window.open(item.eld_link, "_blank")?.focus();
};

let searchCompanyTimer: ReturnType<typeof setTimeout> | null = null;

const searchCompany = (val: string) => {
  companySearchVersion++;

  if (searchCompanyTimer) clearTimeout(searchCompanyTimer);

  searchCompanyTimer = setTimeout(() => {
    searchCompanyTimer = null;
    void fetchCompanyOptions(val);
  }, 300);
};

let searchDriverTimer: ReturnType<typeof setTimeout> | null = null;

const searchDriver = (val: string) => {
  driverSearchVersion++;

  if (searchDriverTimer) clearTimeout(searchDriverTimer);

  searchDriverTimer = setTimeout(() => {
    searchDriverTimer = null;
    void fetchDriverOptions(val);
  }, 300);
};

let searchProblemTimer: ReturnType<typeof setTimeout> | null = null;

const searchProblems = (val: string) => {
  problemSearchVersion++;

  if (searchProblemTimer) clearTimeout(searchProblemTimer);

  searchProblemTimer = setTimeout(() => {
    searchProblemTimer = null;
    void fetchProblemOptions(val);
  }, 300);
};

const openArchiveModal = (item: ITaskData) => {
  archiveModal.value = true;
  archiveReason.value = "";
  archiveModalItem.value = item;
};

const closeArchiveModal = () => {
  archiveModal.value = false;
  archiveReason.value = "";
  archiveModalItem.value = null;
};

const saveArchive = async () => {
  if (!archiveReason.value) return;
  if (!archiveModalItem.value) return;

  await archiveStore.archiveTask(
    loading,
    archiveModalItem.value.id,
    archiveReason.value,
    async (data: any) => {
      if (data) {
        pushNotification("Successfully archived", "success");
        closeArchiveModal();
        await getList();
      }
    }
  );
};

onMounted(async () => {
  companyStore.commonSimpleFilter.search = "";
  driverStore.commonSimpleFilter.search = "";
  workTypeStore.commonFilter.search = "";

  if (userStore.userProfile && userStore.userProfile.team_id) {
    companyStore.commonSimpleFilter.team_id = userStore.userProfile.team_id;
  }

  await getList();
  if (
    userStore.userProfile?.role === "admin" ||
    userStore.userProfile?.role === "super_admin"
  ) {
    isAdmin.value = true;
  }

  if (taskStore.myTaskFilter.search) {
    search.value = taskStore.myTaskFilter.search;
  }

  if (taskStore.myTaskFilter.status) {
    status.value = taskStore.myTaskFilter.status;
  }

  observer = new IntersectionObserver(
    (entries) => {
      if (entries[0]?.isIntersecting) loadMore();
    },
    { root: scrollContainer.value, rootMargin: "200px" }
  );
  if (sentinel.value) observer.observe(sentinel.value);
});

watch(search, (val) => {
  taskStore.myTaskFilter.search = val;

  taskFilterVersion++;

  if (searchTimer) {
    clearTimeout(searchTimer);
  }

  searchTimer = setTimeout(() => {
    searchTimer = null;
    void resetAndFetch();
  }, 300);
});

watch(status, (val) => {
  taskStore.myTaskFilter.status = val;

  if (searchTimer) {
    clearTimeout(searchTimer);
    searchTimer = null;
  }

  void resetAndFetch();
});

watch(
  () => newTask.value.company_id,
  async (val) => {
    driverSearchVersion++;

    if (searchDriverTimer) {
      clearTimeout(searchDriverTimer);
      searchDriverTimer = null;
    }

    driverStore.commonSimpleFilter.search = "";

    const newVal = companies.value.some(
      (item) => item.id.toLowerCase() === val
    );

    drivers.value = [];
    newTask.value.driver_id = "";
    newTask.value.work_type_id = "";

    if (!newVal) {
      if (val) {
        newTask.value.company_name = val;
      } else {
        delete newTask.value.company_name;
      }

      driverStore.commonSimpleFilter.company_id = "";
      drivers.value = [];
    } else {
      delete newTask.value.company_name;

      if (val) {
        driverStore.commonSimpleFilter.company_id = val;
        await fetchDriverOptions("", val);
      }
    }
  }
);

watch(
  () => newTask.value.driver_id,
  (val) => {
    const newVal = drivers.value.some((item) => item.id.toLowerCase() === val);

    if (!newVal) {
      newTask.value.driver_name = val;
    }
  }
);

watch(
  () => appStore.refreshKey,
  () => {
    getList();
  },
  {
    immediate: false,
  }
);

onUnmounted(() => {
  observer?.disconnect();
  taskFilterVersion++;
  companySearchVersion++;
  driverSearchVersion++;
  problemSearchVersion++;
  kpiRequestVersion++;

  if (searchCompanyTimer) clearTimeout(searchCompanyTimer);
  if (searchDriverTimer) clearTimeout(searchDriverTimer);
  if (searchProblemTimer) clearTimeout(searchProblemTimer);
  if (searchTimer) clearTimeout(searchTimer);

  taskStore.clearMyTaskFilter();
  companyStore.clearSimpleFilter();
  driverStore.clearCommonSimpleFilter();
  workTypeStore.clearFilter();
});

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "v-my-tasks",
    ref_key: "scrollContainer",
    ref: scrollContainer
  }, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (kpiLoading.value && !kpiStatistics.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Loading... "))
          : (kpiStatistics.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["v-my-tasks__cards", { 'is-loading': kpiLoading.value }])
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(summaryCards, (card) => {
                  return _createVNode(CustomCard, {
                    key: card.name,
                    class: _normalizeClass(`performance-${card.name}`),
                    label: card.label,
                    number: kpiStatistics.value[card.name]
                  }, null, 8, ["class", "label", "number"])
                }), 64)),
                _createVNode(CustomCard, {
                  label: "Closed %",
                  number: `${kpiStatistics.value.closedRate}%`
                }, null, 8, ["number"])
              ], 2))
            : _createCommentVNode("", true),
        _createVNode(CustomTab, {
          modelValue: performancePeriod.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((performancePeriod).value = $event)),
          tabs: performanceTabs
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(CommonSearch, {
        modelValue: search.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
        icon: _unref(SearchMd),
        placeholder: 'Search',
        clearable: ""
      }, null, 8, ["modelValue", "icon"]),
      _createVNode(CommonDropdown, {
        modelValue: status.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((status).value = $event)),
        items: _unref(statusItems),
        label: "Status",
        position: "bottom",
        clearable: ""
      }, null, 8, ["modelValue", "items"]),
      _createVNode(CommonButton, {
        type: "primary",
        label: `New random task (${taskNumber.value})`,
        prepend: true,
        prependIcon: _unref(Clipboard),
        loading: taskNumberLoading.value,
        onClicked: getNewTask
      }, null, 8, ["label", "prependIcon", "loading"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedByDate.value, (dateGroup, dateIndex) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: dateGroup.date
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["v-my-tasks__date-row", { 'is-collapsed': isDateCollapsed(dateGroup.date) }]),
            onClick: ($event: any) => (toggleDate(dateGroup.date))
          }, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(dateGroup.date), 1),
            _createElementVNode("span", {
              class: _normalizeClass(["v-my-tasks__date-chevron", { 'is-collapsed': isDateCollapsed(dateGroup.date) }])
            }, [
              _createVNode(_unref(ChevronDown), { size: 20 })
            ], 2)
          ], 10, _hoisted_6),
          (!isDateCollapsed(dateGroup.date))
            ? (_openBlock(), _createBlock(CommonTable, {
                key: 0,
                headers: _unref(taskStore).taskHeadersUser,
                items: dateGroup.items,
                loading: loading.value,
                isAdmin: isAdmin.value,
                isTaskTable: "",
                dateIndex: dateIndex
              }, {
                id: _withCtx(({ index }) => [
                  _createElementVNode("span", null, _toDisplayString(dateGroup.items[index].status === "inform"
                    ? ""
                    : dateGroup.items
                        .slice(0, index)
                        .filter((item) => item.status !== "inform")
                        .length + 1), 1)
                ]),
                company: _withCtx(({ item }) => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, [
                      _createTextVNode(_toDisplayString(item.company_name) + " ", 1),
                      (item.company_note)
                        ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_10, [
                            _createVNode(_unref(InfoCircle), { size: 14 })
                          ])), [
                            [_directive_tooltip, {
                      content: item.company_note,
                      html: true,
                    }]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(item.provider_name?.split(" ")[0] || "Hos"), 1)
                  ])
                ]),
                drivers: _withCtx(({ item }) => [
                  _createElementVNode("span", _hoisted_12, [
                    _createTextVNode(_toDisplayString(item.driver_name) + " ", 1),
                    (item.driver_note)
                      ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_13, [
                          _createVNode(_unref(InfoCircle), { size: 14 })
                        ])), [
                          [_directive_tooltip, {
                    content: item.driver_note,
                    html: true,
                  }]
                        ])
                      : _createCommentVNode("", true)
                  ])
                ]),
                date: _withCtx(({ item }) => [
                  _createElementVNode("span", null, _toDisplayString(datepickerToUtcDateOnly(item.created_time)), 1)
                ]),
                status: _withCtx(({ item }) => [
                  (item.status && getStatusEnumKey(item.status))
                    ? (_openBlock(), _createBlock(CommonStatus, {
                        key: 0,
                        status: getStatusEnumKey(item.status)!,
                        onNext: ($event: any) => (nextStatus(item)),
                        onConfirm: ($event: any) => (confirmStatus(item)),
                        onSelected: (e) => selectStatus(item, e),
                        showActions: hasUserHasAction(item),
                        items: availableStatusItems(item),
                        tooltipContent: tooltipContent(item.qa_failed_reason_details)
                      }, null, 8, ["status", "onNext", "onConfirm", "onSelected", "showActions", "items", "tooltipContent"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_14, "—"))
                ]),
                problems: _withCtx(({ item }) => [
                  (!item.isEditingProblem)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("span", _hoisted_16, _toDisplayString(item.description || item.work_type_name), 1),
                        (
                    hasUserHasAction(item) &&
                    item.status == 'in_progress' &&
                    item.source !== 'eld_import'
                  )
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "edit",
                              onClick: ($event: any) => (item.isEditingProblem = true)
                            }, [
                              _createVNode(_unref(Pencil02), { size: 16 })
                            ], 8, _hoisted_17))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createVNode(CustomTableDropdown, {
                          modelValue: item.work_type_id,
                          "onUpdate:modelValue": ($event: any) => ((item.work_type_id) = $event),
                          items: 
                                      problems.value.map((p) => ({
                                        value: p.id,
                                        name: p.name,
                                      }))
                                    ,
                          label: "Problem",
                          position: "bottom",
                          maxWidth: "100%",
                          dropdownFullWidth: "",
                          onSearch: searchProblems
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "items"]),
                        _createElementVNode("div", {
                          class: "clear",
                          onClick: ($event: any) => (item.isEditingProblem = false)
                        }, [
                          _createVNode(_unref(X), { size: 16 })
                        ], 8, _hoisted_19),
                        _createElementVNode("div", {
                          class: _normalizeClass(["problem__save", !item.work_type_id ? 'disabled' : '']),
                          onClick: ($event: any) => (updateProblem(item))
                        }, " Save ", 10, _hoisted_20)
                      ])),
                  _createVNode(TaskAdditionalWorkTypes, {
                    task: item,
                    "work-types": additionalWorkTypes.value,
                    "can-edit": Boolean(hasUserHasAction(item)),
                    onUpdated: ($event: any) => (refreshTaskWorkTypes(item.id))
                  }, null, 8, ["task", "work-types", "can-edit", "onUpdated"])
                ]),
                actions: _withCtx(({ item }) => [
                  (item.eld_link)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createVNode(_unref(LinkExternal02), {
                          size: 16,
                          onClick: ($event: any) => (goLink(item))
                        }, null, 8, ["onClick"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                "new-row": _withCtx(() => [
                  _cache[19] || (_cache[19] = _createElementVNode("td", null, null, -1)),
                  _createElementVNode("td", _hoisted_22, [
                    _createVNode(CustomTableDropdown, {
                      ref_for: true,
                      ref_key: "dropdown1",
                      ref: dropdown1,
                      modelValue: newTask.value.company_id,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newTask.value.company_id) = $event)),
                      items: companyItems.value,
                      label: "Company",
                      position: "bottom",
                      clearable: "",
                      maxWidth: "100%",
                      dropdownFullWidth: "",
                      isAppendItem: "",
                      onEnter: enterFirst,
                      creatable: "",
                      onSearch: searchCompany
                    }, null, 8, ["modelValue", "items"])
                  ]),
                  _createElementVNode("td", _hoisted_23, [
                    _createVNode(CustomTableDropdown, {
                      ref_for: true,
                      ref_key: "dropdown2",
                      ref: dropdown2,
                      modelValue: newTask.value.driver_id,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newTask.value.driver_id) = $event)),
                      items: driverItems.value,
                      label: "Driver",
                      position: "bottom",
                      clearable: "",
                      dropdownFullWidth: "",
                      maxWidth: "100%",
                      isAppendItem: "",
                      onEnter: enterSecond,
                      creatable: "",
                      onSearch: searchDriver
                    }, null, 8, ["modelValue", "items"])
                  ]),
                  _createElementVNode("td", null, _toDisplayString(datepickerToUtcDateOnly(new Date())), 1),
                  _cache[20] || (_cache[20] = _createElementVNode("td", null, "-", -1)),
                  _createElementVNode("td", null, [
                    _createVNode(CommonStatus, {
                      status: getStatusEnumKey(newTaskStatus.value),
                      onNext: _cache[5] || (_cache[5] = ($event: any) => (console.log('Next driver-status'))),
                      onConfirm: _cache[6] || (_cache[6] = ($event: any) => (console.log('Confirm driver-status'))),
                      items: createItems(newTaskStatus.value),
                      onSelected: dropdownSelect,
                      arrow: false,
                      showActions: ""
                    }, null, 8, ["status", "items"])
                  ]),
                  _createElementVNode("td", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(CustomTableDropdown, {
                        ref_for: true,
                        ref_key: "dropdown3",
                        ref: dropdown3,
                        modelValue: newTask.value.work_type_id,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((newTask.value.work_type_id) = $event)),
                        items: problemItems.value,
                        label: "Problem",
                        position: "bottom",
                        clearable: "",
                        dropdownFullWidth: "",
                        isAppendItem: "",
                        onEnter: createNewTask,
                        onSearch: searchProblems
                      }, null, 8, ["modelValue", "items"]),
                      (newTaskStatus.value == 'inform')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "problem__group--edit",
                            onClick: editModal
                          }, [
                            _createVNode(_unref(Pencil02), { size: 16 })
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(["problem__group--save", 
                      isSaving.value ||
                      !problems.value.length ||
                      !newTask.value.company_id ||
                      !newTask.value.driver_id ||
                      !newTask.value.work_type_id
                        ? 'disabled'
                        : ''
                    ]),
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (!isSaving.value && createNewTask()))
                      }, " Save ", 2)
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["headers", "items", "loading", "isAdmin", "dateIndex"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128)),
      _createElementVNode("div", {
        ref_key: "sentinel",
        ref: sentinel,
        class: "v-tasks__sentinel"
      }, null, 512),
      (isLoadingMore.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, " Loading more… "))
        : (!hasMore.value && tasks.value.length && !loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, " No more tasks "))
          : _createCommentVNode("", true)
    ]),
    _createVNode(CommonModal, {
      modelValue: newModal.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((newModal).value = $event)),
      title: "Description"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_29, [
          _createVNode(CommonButton, {
            type: "outline",
            label: "Cancel",
            onClicked: _cache[10] || (_cache[10] = ($event: any) => (newModal.value = false))
          }),
          _createVNode(CommonButton, {
            type: "primary",
            label: "Save",
            onClicked: saveModal
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_28, [
          _createVNode(CommonSearch, {
            modelValue: description.value,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((description).value = $event)),
            placeholder: "Type here ...",
            width: "100%"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(CommonModal, {
      modelValue: archiveModal.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((archiveModal).value = $event)),
      title: "Archive reason"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_32, [
          _createVNode(CommonButton, {
            type: "outline",
            label: "Cancel",
            onClicked: closeArchiveModal
          }),
          _createVNode(CommonButton, {
            type: "primary",
            label: "Save",
            onClicked: saveArchive
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_30, [
          _createVNode(CommonInput, {
            modelValue: archiveReason.value,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((archiveReason).value = $event)),
            label: "Reason",
            multiline: ""
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", {
            class: "item",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (archiveReason.value = 'Duplicate task'))
          }, " Duplicate task "),
          _createElementVNode("div", {
            class: "item",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (archiveReason.value = 'Wrong name'))
          }, "Wrong name"),
          _createElementVNode("div", {
            class: "item",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (archiveReason.value = 'Need to change status'))
          }, " Need to change status "),
          _createElementVNode("div", {
            class: "item",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (archiveReason.value = 'Another worker doing'))
          }, " Another worker doing "),
          _createElementVNode("div", {
            class: "item",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (archiveReason.value = 'Created by mistake'))
          }, " Created by mistake ")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 512))
}
}

})